import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        rolesForm: '='
    },
    template: `
        <table class="data01 mobile-hide">
            <tr>
                <th>{{ 'report.evaluation.Role' | translate }}</th>
                <th>{{ 'report.evaluation.Number of respondents invited' | translate }}</th>
                <th>{{ 'report.evaluation.Actual number of respondents' | translate }}</th>
                <th>{{ 'report.evaluation.Percentage' | translate }}</th>
            </tr>
            <tr ng-repeat="(role, label) in vm.EVALUATION_ROLE_ENUM.LABELS">
                <td>{{ label }}</td>
                <td>{{ vm.rolesForm.roles[role].anticipated ? vm.rolesForm.roles[role].anticipated : 0 }}</td>
                <td>{{ vm.rolesForm.roles[role].actual ? vm.rolesForm.roles[role].actual : 0 }}</td>
                <td>{{ vm.rolesForm.roles[role].percentage ? vm.rolesForm.roles[role].percentage : 0 }}%</td>
            </tr>
            <tr class="total">
                <td>{{ 'report.evaluation.Total' | translate }}</td>
                <td>{{ vm.rolesForm.anticipatedTotal }}</td>
                <td>{{ vm.rolesForm.actualTotal }}</td>
                <td>{{ vm.rolesForm.percentageTotal }}%</td>
            </tr>
        </table>
    `
})
export default class {
    constructor (EVALUATION_ROLE_ENUM) {
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/role/desktop/index.js